module.exports = __webpack_public_path__ + "Roboto-Thin.dfe56a876d0282555d1e.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Thin.eot
// module id = 89
// module chunks = 2